import React from 'react';
import { observer } from 'mobx-react-lite';
import { FiltersMap } from '@wix/bex-core';
import { CollectionTableProps } from '../CollectionTable';
import { InfiniteScrollTableBase } from './InfiniteScrollTableBase';

export interface InfiniteScrollTableV2Props<T, F extends FiltersMap>
  extends CollectionTableProps<T, F> {}

function _InfiniteScrollTableV2<T, F extends FiltersMap = FiltersMap>(
  props: InfiniteScrollTableV2Props<T, F>,
) {
  return <InfiniteScrollTableBase {...props} />;
}

export const InfiniteScrollTableV2 = observer(_InfiniteScrollTableV2);

export { InfiniteScrollTableV2Props as TableV2Props };
export { InfiniteScrollTableV2 as TableV2 };
